
import React, { useState } from 'react';

interface TactilePromptProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (value: string) => void;
  title: string;
  message: string;
  placeholder?: string;
}

const TactilePrompt: React.FC<TactilePromptProps> = ({ isOpen, onClose, onConfirm, title, message, placeholder }) => {
  const [inputValue, setInputValue] = useState('');

  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm(inputValue);
    setInputValue('');
  };

  const handleCancel = () => {
    setInputValue('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center bg-dk-900/80 backdrop-blur-md animate-fade-in">
      <div className="glass-panel max-w-md w-full p-8 rounded-[2rem] border-azure/20 shadow-2xl relative overflow-hidden">
        <div className="relative z-10">
          <h3 className="text-xl font-black text-white italic uppercase tracking-tighter mb-2">{title}</h3>
          <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest leading-relaxed mb-6">{message}</p>
          
          <input 
            type="text" 
            autoFocus
            className="w-full input-glass text-xs py-4 mb-8 uppercase tracking-widest font-black"
            placeholder={placeholder || "Enter value..."}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleConfirm();
              if (e.key === 'Escape') handleCancel();
            }}
          />

          <div className="flex gap-4">
            <button
              onClick={handleCancel}
              className="flex-1 py-3 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:text-white transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="flex-1 btn-azure py-3 text-[10px] font-black uppercase tracking-[0.2em]"
            >
              Confirm
            </button>
          </div>
        </div>
        
        {/* Subtle background glow */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-azure/10 rounded-full blur-3xl"></div>
      </div>
    </div>
  );
};

export default TactilePrompt;
